import { ProductMetaAction, IProductsMetaState, ProductMetaActionType } from './types'

const initialState: IProductsMetaState = {
  page: 1,
  perPage: 20,
  sort: 'id.desc',
  createdAt: [],
  query: '',
  userId: null,
  carrierId: null,
  inventoryLocationIds: [],
  supplierId: null,
  listingStrategyId: null,
  categoryIds: null,
  active: null,
  draft: null,
  hideFulfilled: null,
  recycled: null,
  excludePrinted: null,
  onlyAuthenticated: false,
  tags: [],
  ignoreRecycledFilter: true,
  total: 0
}

export default function ProductMetaReducer(state = initialState, action: ProductMetaActionType): IProductsMetaState {
  switch (action.type) {
    case ProductMetaAction.UPDATE_META: {
      const payload = { ...action.payload }
      if (typeof payload.hasPhotos === 'boolean') {
        payload.hasPhotos = payload.hasPhotos ? 1 : null
      }
      return { ...state, ...payload }
    }

    case ProductMetaAction.RESET_META:
      return initialState

    default:
      return state
  }
}
